const USER_KEY = "USER_DATA";
class UserService {
    setUser(user) {
        try {
            localStorage.setItem(USER_KEY, JSON.stringify(user));
        }
        catch (error) {
            console.error("Failed to store user data:", error);
        }
    }
    getUser() {
        try {
            const userData = localStorage.getItem(USER_KEY);
            if (userData) {
                return JSON.parse(userData);
            }
            return null;
        }
        catch (error) {
            console.error("Failed to retrieve user data:", error);
            return null;
        }
    }
    removeUser() {
        try {
            localStorage.removeItem(USER_KEY);
        }
        catch (error) {
            console.error("Failed to remove user data:", error);
        }
    }
    getUserDisplayName() {
        const user = this.getUser();
        if (user) {
            return (user.name ||
                `${user.firstName || ""} ${user.lastName || ""}`.trim() ||
                "User");
        }
        return "User";
    }
    getUserEmail() {
        const user = this.getUser();
        return (user === null || user === void 0 ? void 0 : user.email) || "";
    }
    getUserInitials() {
        const user = this.getUser();
        if (user) {
            if (user.firstName && user.lastName) {
                return `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`.toUpperCase();
            }
            if (user.name) {
                const nameParts = user.name.trim().split(" ");
                if (nameParts.length >= 2) {
                    return `${nameParts[0].charAt(0)}${nameParts[nameParts.length - 1].charAt(0)}`.toUpperCase();
                }
                return user.name.charAt(0).toUpperCase();
            }
            if (user.email) {
                return user.email.charAt(0).toUpperCase();
            }
        }
        return "U";
    }
    isUserAuthenticated() {
        const user = this.getUser();
        return user !== null && user.id !== undefined;
    }
    getUserRoles() {
        const user = this.getUser();
        return (user === null || user === void 0 ? void 0 : user.roles) || [];
    }
    getUserPermissions() {
        const user = this.getUser();
        return (user === null || user === void 0 ? void 0 : user.permissions) || [];
    }
    hasRole(role) {
        const roles = this.getUserRoles();
        return roles.includes(role);
    }
    hasPermission(permission) {
        const permissions = this.getUserPermissions();
        return permissions.includes(permission);
    }
}
export const userService = new UserService();
export default userService;
